import { Add } from '@mui/icons-material'
import { Alert, Box } from '@mui/material'
import { useState } from 'react'
import { useWorkspaceStore } from '@/store/workspaceStore'
import { invalidateWorkspaceScopedQueries } from '@/services/workspaces/workspaceQueryKeys'
import CreateWorkspaceCard from './CreateWorkspaceCard.jsx'
import WorkspacePickerList from './WorkspacePickerList.jsx'
import { useCreateWorkspace } from '@/hooks/useCreateWorkspace'
import { createWorkspaceErrorMessage } from '@/hooks/createWorkspaceErrorMessage'
import styles from './CreateWorkspace.module.scss'

/** @param {{ workspaces: Array<Record<string, unknown>> }} props */
export default function WorkspacePickerPage({ workspaces }) {
  const [creating, setCreating] = useState(false)
  const setActiveWorkspaceId = useWorkspaceStore((state) => state.setActiveWorkspaceId)
  const { form, submit, onSubmit } = useCreateWorkspace({ switchOnSuccess: false })
  const errorMessage =
    form.submitError || (submit.isError ? createWorkspaceErrorMessage(submit.error) : '')

  const selectWorkspace = (workspaceId) => {
    setActiveWorkspaceId(workspaceId)
    invalidateWorkspaceScopedQueries(workspaceId)
  }

  if (creating) {
    return (
      <Box className={styles.page}>
        {errorMessage ? <Alert severity="error" className={styles.error}>{errorMessage}</Alert> : null}
        <CreateWorkspaceCard
          form={form}
          onSubmit={onSubmit}
          submitLabel={submit.isPending ? 'Creating…' : 'Create workspace'}
        />
        <button type="button" className={styles.backButton} onClick={() => setCreating(false)}>
          Back to workspaces
        </button>
      </Box>
    )
  }

  return (
    <Box className={styles.page}>
      <section className={styles.pickerCard} aria-labelledby="workspace-picker-heading">
        <p className={styles.eyebrow}>DO Chat</p>
        <h1 id="workspace-picker-heading" className={styles.heading}>Choose a workspace</h1>
        <p className={styles.pickerDescription}>Each workspace keeps its chats, projects, and connected apps separate.</p>
        <WorkspacePickerList workspaces={workspaces} onSelect={selectWorkspace} />
        <button type="button" className={styles.newWorkspaceButton} onClick={() => setCreating(true)}>
          <Add fontSize="small" aria-hidden /> Create workspace
        </button>
      </section>
    </Box>
  )
}
